module.exports = __webpack_public_path__ + "static/media/play-c1.20df31bd.svg";